module.exports = __webpack_public_path__ + "assets/img/领取.a8cbd50e.gif";